import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-var
declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-universal-device-check-modal',
    templateUrl: './universal-device-check-modal.component.html',
    styleUrls: ['./universal-device-check-modal.component.scss'],
    standalone: false
})
export class UniversalDeviceCheckModalComponent {

  @ViewChild('universalDeviceCheckModal') universalDeviceModal: ElementRef;

  @Output() confirm = new EventEmitter();
  @Output() deleteDevice = new EventEmitter();

  onConfirm() {
    this.confirm.emit();
    this.closeModal();
  }

  onConfirmDelete() {
    this.deleteDevice.emit();
    this.closeModal();
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.universalDeviceModal.nativeElement).modal('hide');
  }

  openModal() {
    jQuery(this.universalDeviceModal.nativeElement).modal('show');
  }

}
